import { useGetBillingSettingsQuery } from "../api"
import CircularProgress from "@material-ui/core/CircularProgress"
import { BillingSettingsForm } from "./billing-settings-form"

export function BillingSettings({ orgId }: { orgId: string }) {
  const { data: billingSettings, isLoading } = useGetBillingSettingsQuery(orgId)

  if (isLoading) {
    return (
      <div style={{ margin: "auto", display: "flex", justifyContent: "center", alignItems: "center", height: 500 }}>
        <CircularProgress />
      </div>
    )
  }

  if (!billingSettings) {
    return <div>Error loading billing settings.</div>
  }

  const { policyAgreedAt, policyAgreedBy, ...billingSettingsFormValues } = billingSettings

  return (
    <BillingSettingsForm
      orgId={orgId}
      billingSettings={billingSettingsFormValues}
      policyAgreedAt={policyAgreedAt}
      policyAgreedBy={policyAgreedBy}
    />
  )
}
